import { Operation } from '@apollo/client/core';
import { getMainDefinition } from '@apollo/client/utilities';
import { OperationTypeNode } from 'graphql';

export function isSubscription(op: Operation) {
    const definition = getMainDefinition(op.query);

    return (
        definition.kind === 'OperationDefinition' &&
        definition.operation === 'subscription'
    );
}

export function getOperationType(op: Operation): OperationTypeNode | null {
    const definition = getMainDefinition(op.query);

    if (definition.kind !== 'OperationDefinition') return null;

    return definition.operation;
}
